<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="feedPurchaseForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :has-import="true">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="feedPurchase" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                feedPurchaseForm: () => import('../forms/FeedPurchaseForm'),
                feedPurchase: () => import('../editViews/FeedPurchase'),
                headers: [
                    { text: 'Member', value: 'memberId', table: 'members', form: () => import('../forms/MemberForm') },
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Feed', value: 'feedId', table: 'feeds', form: () => import('../forms/FeedForm') },
                    { text: 'Dose Rate', value: 'doseRate' },
                    { text: 'Product Name', value: 'productName' },
                    { text: 'Invoice File', value: 'invoiceFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    feeds: [],
                    files: [],
                    members: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "doseRate", direction: "ascending" },
                    { column: "memberId", direction: "ascending" },
                    { column: "feedId", direction: "ascending" },
                ],
                itemsField: 'feedPurchases',
                editPageName: 'feedPurchase',
                apiMethod: 'FeedPurchases',
                claimName: 'FeedPurchases',
                formTitle: 'Feed Purchase',
                excelTitle: 'Feed Purchases',
                hasEditPage: true,
            }
        },
    };
</script>
